import { Button, Modal } from "antd";
import React, { useState } from "react";
import { checkActionAllowed } from "../../utils/utilities";
import { VIEW_AGENT_TRIP_CREATE } from "../../utils/constant";

export const GetServiceId = (props) => {

    const {
        schedule
    } = props;

    const [isModalVisible, setModalVisible] = useState(false);

    const handleCancel = () => {
        setModalVisible(false);
    }

    if (checkActionAllowed(VIEW_AGENT_TRIP_CREATE)) {
        return (
            <div>
                <Button
                    onClick={() => {
                        setModalVisible(true);
                    }}
                    className="bordered-btn send-driver-details-btn"
                >Get Service Details</Button>
                <Modal
                    title={"Service Details"}
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <div>Service Id : <span style={{ fontWeight: 'bold' }}>{schedule.schedule_id}</span></div>
                    <div>Seats blocked by default: <span style={{ fontWeight: 'bold' }}>{schedule.blocked_seat_numbers}</span></div>
                </Modal>
            </div>
        )
    } else {
        return null;
    }
}
